package com.gloopgo.game.ui

import com.gloopgo.game.engine.GameConstants

actual fun getAppPlatformInfo(): AppPlatformInfo {
    val detectedOs = try {
        js("""
            (function() {
                if (typeof window === 'undefined' || !window.navigator) return "Web";
                var nav = window.navigator;
                var ua = nav.userAgent || "";

                // Check modern Chromium userAgentData first if supported
                if (nav.userAgentData && nav.userAgentData.platform) {
                    var p = ("" + nav.userAgentData.platform).toLowerCase();
                    if (p.indexOf("mac") !== -1) return "macOS";
                    if (p.indexOf("win") !== -1) return "Windows";
                    if (p.indexOf("android") !== -1) return "Android";
                    if (p.indexOf("linux") !== -1) return "Linux";
                    if (p.indexOf("ios") !== -1) return "iOS";
                    if (p.indexOf("cros") !== -1) return "ChromeOS";
                }

                // iPadOS Safari reports Macintosh but has touch points
                if (/Macintosh/i.test(ua) && nav.maxTouchPoints && nav.maxTouchPoints > 1) {
                    return "iPadOS";
                }
                if (/iPhone|iPod/i.test(ua)) {
                    return "iOS";
                }
                if (/iPad/i.test(ua)) {
                    return "iPadOS";
                }
                if (/Android/i.test(ua)) {
                    return "Android";
                }
                if (/Macintosh|Mac OS X/i.test(ua)) {
                    return "macOS";
                }
                if (/Windows|Win32|Win64/i.test(ua)) {
                    return "Windows";
                }
                if (/CrOS/i.test(ua)) {
                    return "ChromeOS";
                }
                if (/Linux|X11/i.test(ua)) {
                    return "Linux";
                }
                return nav.platform || "Web";
            })()
        """) as? String ?: "Web"
    } catch (_: Throwable) {
        "Web"
    }

    return AppPlatformInfo(
        appVersion = GameConstants.APP_VERSION,
        isWeb = true,
        webOsName = detectedOs
    )
}
